// extracted by mini-css-extract-plugin
export default {"input":"AddSemisterForm_input__L4ytl","del":"AddSemisterForm_del__i3caL"};